module.exports = __webpack_public_path__ + "img/tp.20ff47a8.png";